import { WfConstants } from "./WfConstants";

export class WfDesignerUtils {
    /**
     * 是否为共享流程构件
     * @param metadataId 
     * @returns 
     */
    public static isPfComponent(metadataId: string) {
        if (metadataId === WfConstants.PF_CMP_ID1
            || metadataId === WfConstants.PF_CMP_ID2
            || metadataId === WfConstants.PF_CMP_ID3
            || metadataId === WfConstants.PF_CMP_ID4) {
            return true;
        }
        return false;
    }

    /**
     * 创建内码
     */
    public static createNM() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }
}